module.exports = __webpack_public_path__ + "img/revenues-types-x.4a119cf4.svg";